import {
  RECEIVE_ADVERTISER_WITH_ORDERS,
  REQUEST_ADVERTISER_WITH_ORDERS,
  API_CALL
} from "./types";
import { getPreferences } from "../preferences"

export const getAdvertiser = advertiserId => ({
  type: API_CALL,
  onRequest: REQUEST_ADVERTISER_WITH_ORDERS,
  onResponse: RECEIVE_ADVERTISER_WITH_ORDERS,
  onError: 'ADVERTISER_WITH_ORDERS_FAILED',
  payload: {
    id: advertiserId,
    method: 'GET',
    url: `/advertisers/${advertiserId}?minDate=${getPreferences().minDateCutoff || ''}`
  },
  advertiserId
});
